import { createActionGroup, props } from '@ngrx/store';

export const SharedActions = createActionGroup({
  source: 'Shared',
  events: {
    Login: props<{ email: string; password: string; remember: boolean }>(),
    'Login Success': props<{ token: string; remember: boolean }>(),
    // `errorCode?` et non `errorCode` : l'effet le tire de
    // `error?.error?.error`, qui vaut `undefined` des que le serveur ne
    // renvoie pas de corps -- coupure reseau, 500 nu, passerelle. Le declarer
    // obligatoire etait un mensonge que seul `any` rendait invisible au
    // compilateur, du cote de l'effet comme du lecteur.
    'Login Failure': props<{ errorCode?: string }>(),
  },
});
